import '../../snippets/product-tags/product-tags.scss';

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

function setCookie(name, value, days) {
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + d.toUTCString();
  document.cookie = name + '=' + value + ';' + expires + ';path=/';
}

function addProductToRecentlyViewed(productHandle) {
  let recentlyViewed = getCookie('recently_viewed') ? JSON.parse(getCookie('recently_viewed')) : [];

  if (!recentlyViewed.includes(productHandle)) {
    recentlyViewed.push(productHandle);
  }

  let recentlyLimit = window.dAgency?.recentlyLimit || 8;

  if (recentlyViewed.length > recentlyLimit) {
    recentlyViewed.shift();
  }

  setCookie('recently_viewed', JSON.stringify(recentlyViewed), 30);
}

async function displayRecentlyViewed() {
  // Get recently viewed products from the cookie
  const recentlyViewed = getCookie('recently_viewed') ? JSON.parse(getCookie('recently_viewed')) : [];

  const section = document.querySelector('.recently-viewed__section');
  if (!section) return;

  // Hide the section if no recently viewed products
  if (!recentlyViewed.length) {
    section.style.display = 'none';
    return;
  }

  section.style.display = 'block';

  const container = document.querySelector(
    '.recently-viewed__container .recently-viewed__list-container .carousel__slider-wrapper .swiper-wrapper',
  );
  if (!container) return;

  // Get semantic tag preferences with sensible defaults
  const productTitleTag = container.dataset?.productTitleTag;
  const productVendorTag = container.dataset?.productVendorTag;

  // Clear the container before adding new products
  container.innerHTML = '';

  // Map over each product handle and fetch its HTML via the sr-product-tile section (`?sections=sr-product-tile`)
  const root = window.Shopify?.routes?.root || '/';
  const fetches = recentlyViewed.map(async (handle) => {
    try {
      const res = await fetch(`${root}products/${handle}?sections=sr-product-tile`);
      if (!res.ok) throw new Error(`Failed to fetch product tile for ${handle}`);

      const data = await res.json();
      const html = data['sr-product-tile'];
      if (!html) throw new Error('No sr-product-tile section in response');

      const wrapper = document.createElement('div');
      wrapper.innerHTML = html;

      const productContent = wrapper.firstElementChild;
      if (!productContent) throw new Error('No productContent found in section');

      // Add unique id to the product
      productContent.id = `recently-viewed-${handle}`;
      // Add swiper-slide class
      productContent.classList.add('swiper-slide');

      const productTileContainer = productContent.querySelector('.product-tile__container');

      if (productTileContainer) {
        // Add product_title_tag_param
        if (productTitleTag) productTileContainer.dataset.productTitleTag = productTitleTag;
        // Add product_vendor_tag_param
        if (productVendorTag) productTileContainer.dataset.productVendorTag = productVendorTag;

        return productContent;
      }
      return null;
    } catch (err) {
      console.error('Error loading product tile', err);
      return null;
    }
  });

  // Wait for all product fetches to complete
  const products = await Promise.all(fetches);

  // Append products in the original recentlyViewed order
  products.forEach((productContent) => {
    if (!productContent) return;

    container.appendChild(productContent);

    // Initialize quick buy modal if it exists
    const quickBuyModal = productContent.querySelector('.quick-buy__container');
    if (quickBuyModal && typeof window?.dAgency?.initQuickBuy === 'function') {
      window.dAgency.initQuickBuy(quickBuyModal);
    }

    // Initialize product tile features (wishlist, hover effects, etc.)
    if (typeof window?.dAgency?.initProductTile === 'function') {
      window.dAgency.initProductTile(productContent);
    }
  });

  // Remove processed dataset attribute
  if (productTitleTag) delete container.dataset.productTitleTag;
  if (productVendorTag) delete container.dataset.productVendorTag;

  // Initialize the carousel ONCE after all products are loaded
  const carouselContainer = container
    .closest('.recently-viewed__list-container')
    ?.querySelector('.carousel__container');

  if (carouselContainer && typeof window?.dAgency?.initCarousel === 'function') {
    // Force browser reflow to ensure layout is ready
    carouselContainer.offsetHeight;

    window.dAgency.initCarousel(carouselContainer);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const productContainer = document.querySelector('.product-page__section');

  // Add product to Recently Viewed (product page only)
  if (productContainer) {
    const url = window.location.pathname;
    const productHandle = url.split('/').pop();

    if (productHandle) {
      addProductToRecentlyViewed(productHandle);
    }
  }

  // Selectors for pages where Recently Viewed should be displayed
  const recentlyViewedSelectors = ['.product-page__section', '.collection-page__container', '.cart-page__container'];

  const shouldDisplayRecentlyViewed = recentlyViewedSelectors.some((selector) => document.querySelector(selector));

  if (shouldDisplayRecentlyViewed) {
    displayRecentlyViewed();
  }
});
